<template>
  <div id='playlist'>
    <div class="playBox">
      <div class="pd25">
        <mTitle :isShowRightText="false" :title="'农业新闻'" class="pcbox"></mTitle>

        <mTitle :isShowRightText="false" :isPaddingLeft="true" :title="'农业新闻'" class="mobileBox"></mTitle>
      </div>
      <div class="newsBox">
        <div class="newsContentView" v-for="item in categories" @click="toDetail(item.xid)">
          <div class="newLeftBox">
            <div  class="widBox">
              <div class="moonFont">{{item.day}}</div>
              <div class="yearFont">{{item.yearMonth}}</div>
            </div>
            

          </div>
          <div class="newRightBox">
            <div class="newsTitle">{{item.title}}</div>
            <div class="newsContent">{{removeHtmlTags(item.content)}}</div>
          </div>
        </div>

      </div>
      <div class="paginBox" >
        <div class="countNumber">
          共{{count}}条
        </div>
        <div class="rightPagin">
          <el-pagination
          @size-change="sizePagination"
          @current-change="currentPagination"
          :pager-count="3"
          :page-size="filters.pageSize"
      background
      layout="prev, pager, next"
      :total="count">
</el-pagination>
        </div>

</div>
    </div>




  </div>
</template>

<script>
import mTitle from "@/components/TitleHead/index.vue";
export default {
  name: 'Playlist',
  components: { mTitle },
  data() {
    return {
      categories:[],
      count:0,
      filters:{
        currPage:1,
        pageSize:12
      }
    }
  },
  mounted() {
    // this.$API.getCatlist().then(res => {
    //   if (res.data.code === 200) {
    //     this.categories = res.data.categories
    //     this.sub = res.data.sub
    //   }
    // })
    this.getPlaylist()
  },
  methods: {
    removeHtmlTags(str){
      return str.replace(/<[^>]*>/g, '');  // 正则表达式匹配所有HTML标签
    },
    sizePagination(e){
      this.filters.currPage=e
      this.getPlaylist()
    },
    currentPagination(e){
      this.filters.currPage=e
      this.getPlaylist()
    },
    getPlaylist(){
         this.$API.getCatlist(this.filters).then(res => {
      if (res.code === 200) {
        this.categories = res.data.list
        this.categories.forEach(item =>{
          item.yearMonth = item.release.split("-")[0]+"-"+item.release.split("-")[1]
          item.day = item.release.split("-")[2]
        })
        this.count = res.data.pageInfo.allRows
      }
    })
    },
    toDetail(xid){
      this.$router.push({path:'/playlistDetail',query: { id: xid }})
    }
  },
}
</script>

<style scoped lang='less'>
//移动端
@media (max-width: 768px) {

  ::v-deep .el-pagination.is-background .btn-prev{
  background: none;
}
::v-deep .el-pagination .btn-next .el-icon{
  font-size: 16px;
}
::v-deep .el-pagination .btn-prev .el-icon {
  font-size: 16px;
}
::v-deep .btn-next{
  width: 24px;
  height: 24px;
  background-color: #FFFFFF !important;
border-radius: 3px 3px 3px 3px;
border: 1px solid #E5E5E5;
}
::v-deep .btn-prev{
  width: 24px;
  height: 24px;
  background-color: #FFFFFF !important;
border-radius: 3px 3px 3px 3px;
border: 1px solid #E5E5E5;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
background: #FFFFFF;
border-radius: 3px 3px 3px 3px;
border: 1px solid #005431;
font-weight: bold;
font-size: 16px;
color: #005431;
text-align: center;
font-style: normal;
text-transform: none;
}
::v-deep .el-pagination.is-background .el-pager li{
border-radius: 3px 3px 3px 3px;
border: 1px solid #B4B4B4;
background: none;
width: 24px;
height: 24px;
font-weight: 500;
font-size: 13px;
color: #313131;
text-align: center;
font-style: normal;
text-transform: none;
line-height: 20px;
}
  .rightPagin{
    padding-right: 10px;
  }
  .countNumber{
font-weight: 500;
font-size: 13px;
color: #313131;
text-align: left;
font-style: normal;
text-transform: none;
  }
  .paginBox{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left:10px;
    padding-bottom: 20px;
  }
  .newsBox{
    padding-bottom: 20px;
  }
  .pcBox{
    display: none !important;
  }
  .widBox{
    width: 52px;
    height: 52px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .newsContent {
    margin-top: 8px;

font-weight: 500;
font-size: 13px;
color: #7A7A7A;
line-height: 24px;
text-align: left;
font-style: normal;
text-transform: none;
    white-space: nowrap;
    /* 不换行 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 溢出部分显示省略号 (...) */
  }

  .newsTitle {
font-weight: 800;
font-size: 16px;
color: #313131;
text-align: left;
font-style: normal;
text-transform: none;
    white-space: nowrap;
    /* 不换行 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 溢出部分显示省略号 (...) */
  }
  .newRightBox {
    width: 80%;
    padding-left: 10px; /* 给右边内容留点空隙 */
  }
  .newsContentView {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    padding:0 10px;
  }
  .moonFont {
    font-size: 16px;
  }

  .yearFont {
    font-size: 10px;
    margin-top: 3px;
  }
  .newLeftBox {
    background: #005431;
    color: #fff;

  }
  .pd25{
    padding-top: 10px;
  }
  .pcbox{
    display: none !important;
  }
  .playBox{
    width: 363px;
    margin: 10px auto;
  background: #fff;

}
}
//pc端
@media (min-width: 769px) {
  .mobileBox{
    display: none !important;
  }
  .countNumber{
font-weight: 500;
font-size: 16px;
color: #313131;
text-align: left;
font-style: normal;
text-transform: none;
}
.paginBox{
  display: flex;justify-content: space-between;padding: 40px 20px;align-items: center;
  }
::v-deep .el-pagination.is-background .btn-prev{
  background: none;
}
::v-deep .el-pagination .btn-next .el-icon{
  font-size: 18px;
}
::v-deep .el-pagination .btn-prev .el-icon {
  font-size: 18px;
}
::v-deep .btn-next{
  width: 36px;
  height: 36px;
  background-color: #FFFFFF !important;
border-radius: 3px 3px 3px 3px;
border: 1px solid #E5E5E5;
}
::v-deep .btn-prev{
  width: 36px;
  height: 36px;
  background-color: #FFFFFF !important;
border-radius: 3px 3px 3px 3px;
border: 1px solid #E5E5E5;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
background: #FFFFFF;
border-radius: 3px 3px 3px 3px;
border: 1px solid #005431;
font-weight: bold;
font-size: 16px;
color: #005431;
text-align: center;
font-style: normal;
text-transform: none;
}
::v-deep .el-pagination.is-background .el-pager li{
border-radius: 3px 3px 3px 3px;
border: 1px solid #B4B4B4;
background: none;
width: 36px;
height: 36px;
font-weight: 500;
font-size: 16px;
color: #313131;
text-align: center;
font-style: normal;
text-transform: none;
line-height: 35px;
}
  .yearFont {
    font-size: 12px;
    margin-top: 3px;
  }
.pd25{
  padding:25px;
}

  .newLeftBox {
    width: 60px;
    height: 60px;
    background: #005431;
    color: #fff;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
.playBox{
  width: 1200px;
  margin: 0 auto;
  min-height: calc(100vh - 200px);
  background: #fff;
  margin-top: 10px;

}
.newsContentView {
    display: flex;
    margin-bottom: 14px;
    padding: 0 25px;
  }

  .swiperBox {
    display: flex;
    padding-top: 10px;
  }

  .newRightBox {
    margin-left: 10px;
    width: 1078px;
  }
  .widBox{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .newsContent {
    font-weight: 500;
    font-size: 14px;
    color: #7A7A7A;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 10px;
    white-space: nowrap;
    /* 不换行 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 溢出部分显示省略号 (...) */
  }

  .newsTitle {
    font-weight: 800;
    font-size: 16px;
    color: #313131;
    text-align: left;
    font-style: normal;
    text-transform: none;
    white-space: nowrap;
    /* 不换行 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 溢出部分显示省略号 (...) */
  }

  .newsBox {
    display: flex;
    flex-direction: column;
    height: 869px;
  }
}

</style>

